export default "__VITE_ASSET__43e6cee4__"